import LoginComponent from '@/components/login/login.component';
import { MyPage } from '@/types/my-page.type';

const Login: MyPage = () => {
  return <LoginComponent />;
};
export default Login;
Login.layout = 'Auth';
Login.isNotProtected = true;
